import React, { useState } from "react"

import {
  Button,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import Spinners from "components/Common/Spinner"
import { formatAmount, sanitizeIntegerInput } from "helpers/common"
import "flatpickr/dist/themes/material_blue.css"
import FlatPickr from "react-flatpickr"

function PaymentUtrModel({
  icd,
  open,
  setOpen,
  errors,
  setErrors,
  handlePayment,
  isLoading,
}) {
  const toggle = () => setOpen(!open)

  const [payments, setPayments] = useState([
    { amount: "", itr: "", date_of_payment: "" },
  ])

  const handleChange = (index, field, value) => {
    const updated = [...payments]
    updated[index][field] = value
    setPayments(updated)
    clearFieldError(index, field)
  }

  const addRow = () => {
    setPayments([...payments, { amount: "", itr: "", date_of_payment: "" }])
  }

  const removeRow = (index) => {
    setPayments(payments.filter((_, i) => i !== index))
  }

  const onSubmit = (e) => {
    e.preventDefault()
    handlePayment({ payments })
  }

  const getError = (index, field) => {
    return errors[`payments.${index}.${field}`]
  }

  const clearFieldError = (index, field) => {
    const key = `payments.${index}.${field}`
    if (errors[key]) {
      const updated = { ...errors }
      delete updated[key]
      setErrors(updated)
    }
  }

  return (
    <div>
      <Modal isOpen={open} toggle={toggle} centered size="lg">
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          Pay Offline
        </ModalHeader>
        <ModalBody>
          <Container>
            <Row className="mb-2">
              <Col xl={12} className="mb-2">
                <h5 className="form-label">Bank Account</h5>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xl={6} xs={12}>
                <Label className="form-label">Name</Label>
                <p>Prachay Capital Limited</p>
              </Col>
              <Col xl={6} xs={12}>
                <Label className="form-label">Account No</Label>
                <p>2306234047941198</p>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xl={6} xs={12}>
                <Label className="form-label">IFSC Code</Label>
                <p>AUBL0002340</p>
              </Col>
              <Col xl={6} xs={12}>
                <Label className="form-label">Account Type</Label>
                <p>Overdraft facility</p>
              </Col>
            </Row>
            <Row>
              <Col xl={12} xs={12}>
                <Label className="form-label">Bank & Branch</Label>
                <p>AU Small Finance Bank, Mumbai Andheri Kurla Road</p>
              </Col>
            </Row>
            <hr />
            <Form className="form-horizontal" onSubmit={onSubmit}>
              <Row className="mb-2">
                <Col xl={6} className="mb-2">
                  <Label className="form-label" htmlFor="amount">
                    Already Paid Amount
                  </Label>
                  <h5>
                    ₹{" "}
                    {formatAmount(
                      icd?.investorsPayments?.reduce(
                        (sum, item) => sum + (item.amount || 0),
                        0
                      ) || 0
                    )}
                  </h5>
                </Col>
                <Col xl={6} className="mb-2">
                  <Label className="form-label" htmlFor="amount">
                    Total Amount
                  </Label>
                  <h5>₹ {formatAmount(icd?.amount || 0)}</h5>
                </Col>
                {payments.map((item, index) => (
                  <React.Fragment key={`paymentFields_${index}`}>
                    <Col xl={3} className="mb-2">
                      <Label className="form-label" htmlFor="amount">
                        Amount
                      </Label>
                      <Input
                        name="amount"
                        id="amount"
                        className="form-control"
                        placeholder={"Enter amount"}
                        type="text"
                        value={`₹ ${formatAmount(item.amount)}`}
                        onChange={(e) =>
                          sanitizeIntegerInput(e, (name, val) =>
                            handleChange(index, "amount", val)
                          )
                        }
                        invalid={!!getError(index, "amount")}
                      />
                      <FormFeedback>{getError(index, "amount")}</FormFeedback>
                    </Col>
                    <Col xl={4} className="mb-2">
                      <Label className="form-label" htmlFor="itr">
                        UTR number
                      </Label>
                      <Input
                        name="itr"
                        id="itr"
                        className="form-control"
                        placeholder={"Enter UTR number"}
                        type="text"
                        value={item.itr}
                        onChange={(e) =>
                          handleChange(index, "itr", e.target.value)
                        }
                        invalid={!!getError(index, "itr")}
                      />
                      <FormFeedback>{getError(index, "itr")}</FormFeedback>
                    </Col>
                    <Col xl={3} className="mb-2">
                      <Label className="form-label" htmlFor="itr">
                        Payment Date
                      </Label>
                      <FlatPickr
                        id="date_of_payment"
                        name="date_of_payment"
                        className={`form-control ${
                          getError(index, "date_of_payment") ? "is-invalid" : ""
                        }`}
                        placeholder="Select date"
                        options={{
                          dateFormat: "d M, Y",
                          maxDate: "today",
                        }}
                        value={item.date_of_payment}
                        onChange={(date) =>
                          handleChange(index, "date_of_payment", date[0])
                        }
                      />
                      <FormFeedback>
                        {getError(index, "date_of_payment")}
                      </FormFeedback>
                    </Col>
                    <Col xl={2} className="mb-2">
                      {index === payments.length - 1 ? (
                        <Button
                          type="button"
                          className="btn btn-secondary"
                          style={{
                            marginTop: "30px",
                            width: "100%",
                          }}
                          onClick={() => addRow()}
                        >
                          <i className="mdi mdi-plus me-1"></i>
                        </Button>
                      ) : (
                        <Button
                          type="button"
                          color="danger"
                          style={{
                            marginTop: "30px",
                            width: "100%",
                          }}
                          onClick={() => removeRow(index)}
                        >
                          <i className="mdi mdi-minus" />
                        </Button>
                      )}
                    </Col>
                  </React.Fragment>
                ))}
              </Row>

              <div className="mt-3 py-1 button-wrapper">
                <Button
                  type="submit"
                  color="primary"
                  className="w-100"
                  disabled={isLoading}
                  onClick={() => handlePayment}
                >
                  {isLoading ? <Spinners /> : "Submit"}
                </Button>
              </div>
            </Form>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default PaymentUtrModel
